import React from "react";
import { useSelector } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { addtoCard } from "../redux/actions/productAction";
import { useDispatch } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import cher from "../assets/svg/cher.svg";

import "../styles/Produits.css";
import { useState } from "react";

const Produits = () => {
  const produits = useSelector((state) => state.touslesProduits.produits);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const ppr = [
    { id: 1, name: "PC Portable", nb: 23, icon: <i class="fas fa-check"></i> },
    { id: 2, name: "Telephone", nb: 23, icon: <i class="fas fa-check"></i> },
    { id: 3, name: "Chemise", nb: 23, icon: <i class="fas fa-check"></i> },
    { id: 4, name: "Pontalon", nb: 23, icon: <i class="fas fa-check"></i> },
    { id: 5, name: "Chaussure", nb: 23, icon: <i class="fas fa-check"></i> },
    { id: 6, name: "Bracelet", nb: 23, icon: <i class="fas fa-check"></i> },
    { id: 7, name: "Tricot", nb: 23, icon: <i class="fas fa-check"></i> },
    { id: 8, name: "Disque Dur", nb: 23, icon: <i class="fas fa-check"></i> },
    {
      id: 9,
      name: "Television",
      nb: 23,
      icon: <i class="fas fa-arrow-down"></i>,
    },
    { id: 10, name: "Short", nb: 23, icon: <i class="fas fa-arrow-down"></i> },
  ];

  const catego = [
    { id: 1, name: "electronics" },
    { id: 2, name: "jewelery" },
    { id: 3, name: "men's clothing" },
    { id: 4, name: "women's clothing" },
  ];

  const categoName = (
    <select
      onChange={(event) => handleChange(event.target.value)}
      className="form-select selECT"
      aria-label="Default select example"
    >
      <option value="">Choisir la categorie</option>
      {catego.map((catame) => {
        return (
          <option key={catame.id} className="optION">
            {catame.name}
          </option>
        );
      })}
    </select>
  );

  const handleChange = (categ) => {
    navigate(`/produit/${categ}`);
    // console.log(categ);
  };

  const Ajout = (x) => {
    dispatch(addtoCard(x));
    toast.success("Le Produit est bien ajouter dans le panier!", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const [tog, setTog] = useState(true);
  const display = () => {
    setTog(!tog);
  };
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div className={tog ? "MenuEtProduits" : "MenuEtProduits togg"}>
        <div className="menuAgauche">
          <div className="recherche">
            <input type="text" className="child" placeholder="rechercher..." />
            <i className="fa fa-search fa-2x child"></i>
          </div>
          <div className="vet">
            <div className="vetTitre">
              Les Categories
              {categoName}
            </div>
            <ul>
              {ppr.map((pr) => {
                const { id, name, nb, icon } = pr;
                return (
                  <li key={id}>
                    <div>{name}</div>
                    <div>
                      {nb} {icon}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        {/* <div className="touss"> */}
        <div>
          <button
            type="button"
            className="btnDisplay"
            onClick={() => display()}
          >
            <img src={cher} alt="chercher" />
          </button>
          <div class="container">
            {produits.map((produit) => {
              const { id, category, image, title } = produit;
              return (
                <div key={id} class="card">
                  <div class="card__thumb">
                    <img
                      src={image}
                      alt="Picture by Kyle Cottrell"
                      class="card__image"
                    />
                    <div class="card__caption">
                      <h2 class="card__title">{category}</h2>
                      <p class="card__snippet">{title}.</p>
                      <Link className="linkBtn" to={`/produits/${id}`}>
                        <div class="card__button">Detail</div>
                      </Link>
                      <button
                        type="button"
                        class="card__button"
                        onClick={() => Ajout(produit)}
                      >
                        Ajouter au Panier
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};
export default Produits;
